// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointIdFromJSON, DatapointIdToJSON, } from './';
export function DatapointFilterItemFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'datapoint': DatapointIdFromJSON(json['datapoint']),
    };
}
export function DatapointFilterItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'datapoint': DatapointIdToJSON(value.datapoint),
    };
}
